import { IPublishTerm } from '../../../../../../repositories/billing-tariffs/entities/PublishTerms/PublishTerm';
import { ERestrictionType, IRestriction } from '../../../../../../reducers/v2';
import { defaultState } from '../../../../../../reducers/v2/promotion/defaultState';
import { isPromotionForbidden } from './isPromotionForbidden';
import { defaultTo } from 'ramda';
import { mapRestrictionType } from './mapRestrictionType';

export function getRestrictions(terms: IPublishTerm[] | undefined): IRestriction {
  if (!terms || terms.length === 0) {
    return defaultState.restriction;
  }

  const isAllowed = !isPromotionForbidden(terms);

  return {
    isAllowed,
    restrictionType: isAllowed
      ? undefined
      : defaultTo(ERestrictionType.DeniedBySanctions, mapRestrictionType(terms[0].unavailableReasonType!)),
  };
}
